export default {
  "recent_activity":"Letzte Aktivität",
  "you_have_unfinished_invoice":"Sie haben eine unvollständige Rechnung",
  "you_have_unfinished_estimate":"Sie haben einen unvollständigen voranschlag",
  "invoice":"Rechnung",
  "estimate":"voranschlag",
  "home":"Startseite",
  "document":"Dokument",
  "client":"Kunde",
  "report":"Bericht",
  "new":"Neu",
  "no_client_found":"Kein Kunde gefunden.",
  "search":"Suche",
  "clients":"Kunden",
  "documents":"Dokumente",
  "no_document_found":"Kein Dokument gefunden.",
  "cancel":"Abbrechen",
  "new_client":"Neuer Kunde",
  "add_client":"Kunde hinzufügen",
  "client_name_is_required":"Kundenname ist erforderlich!",
  "client_name":"Kundenname",
  "email":"E-Mail",
  "phone":"Telefon",
  "mobile":"Handy",
  "fax":"Fax",
  "address":"Adresse",
  "address_1":"Adresse 1",
  "address_2":"Adresse 2",
  "city":"Stadt",
  "state_province":"Bundesland/Provinz",
  "zip_postal_code":"PLZ",
  "country":"Land",
  "filter_documents":"Dokumente filtern",
  "apply_filter":"Filter anwenden",
  "document_type":"Dokumenttyp",
  "all":"Alle",
  "send_state":"Sendestatus",
  "sent":"Gesendet",
  "not_sent":"Nicht gesendet",
  "payment_state":"Zahlungsstatus",
  "paid":"Bezahlt",
  "not_paid":"Nicht bezahlt",
  "overdue":"Überfällig",
  "date":"Datum",
  "this_month":"Diesen Monat",
  "this_year":"Dieses Jahr",
  "custom":"Benutzerdefiniert",
  "from":"Von",
  "to":"Bis",
  "preview":"Vorschau",
  "summary":"Zusammenfassung",
  "estimate_number":"voranschlagsnummer",
  "issued":"Ausgestellt",
  "valid_until":"Gültig bis",
  "history":"Verlauf",
  "show":"Anzeigen",
  "share":"Teilen",
  "print":"Drucken",
  "download_pdf":"PDF herunterladen",
  "send_estimate":"voranschlag senden",
  "document_history":"Dokumentverlauf",
  "mark_as_paid":"Als bezahlt markieren",
  "paid":"Bezahlt",
  "invoice_number":"Rechnungsnummer",
  "due":"Fällig",
  "send_invoice":"Rechnung senden",
  "new_item":"Neuer Artikel",
  "name":"Name",
  "price":"Preis",
  "item_name":"Artikelname",
  "item_price":"Artikelpreis",
  "item_name_is_required":"Artikelname ist erforderlich!",
  "item_price_is_required":"Artikelpreis ist erforderlich!",
  "item_tax_state":"Artikelsteuerstatus",
  "add_item":"Artikel hinzufügen",
  "new_service":"Neue Dienstleistung",
  "unit":"Einheit (Stunde, Tag)",
  "service_name_is_required":"Dienstleistungsname ist erforderlich!",
  "service_price_is_required":"Dienstleistungspreis ist erforderlich!",
  "tax":"Steuer",
  "service_tax_state":"Dienstleistungssteuerstatus",
  "add_service":"Dienstleistung hinzufügen",
  "items_and_services":"Artikel & Dienstleistungen",
  "items":"Artikel",
  "item":"Artikel",
  "services":"Dienstleistungen",
  "update_item":"Artikel aktualisieren",
  "are_you_sure":"Sind Sie sicher?",
  "this_action_will_delete_the_item":"Diese Aktion löscht den Artikel.",
  "delete":"Löschen",
  "update":"Aktualisieren",
  "update_service":"Dienstleistung aktualisieren",
  "this_action_will_delete_the_service":"Diese Aktion löscht die Dienstleistung.",
  "business":"Unternehmen",
  "business_details":"Unternehmensdetails",
  "business_details_1":"Unternehmensdetails",
  "business_logo":"Unternehmenslogo",
  "business_name":"Unternehmensname",
  "business_name_is_required":"Unternehmensname ist erforderlich!",
  "mobile_number":"Handynummer",
  "mobile_number_2":"Handynummer 2",
  "website":"Webseite",
  "street":"Straße",
  "street_2":"Straße 2",
  "save":"Speichern",
  "settings":"Einstellungen",
  "business_settings":"Unternehmenseinstellungen",
  "payment_options":"Zahlungsoptionen",
  "tax_settings":"Steuereinstellungen",
  "document_settings":"Dokumenteinstellungen",
  "template_design_and_settings":"Vorlagendesign & Einstellungen",
  "app_settings":"App-Einstellungen",
  "language":"Sprache",
  "theme":"Thema",
  "dark":"Dunkel",
  "light":"Hell",
  "auto":"Automatisch",
  "subscription":"Abonnement",
  "rate_us":"Bewerten Sie uns",
  "paypal_email_is_required":"PayPal-E-Mail ist erforderlich",
  "online_payments":"Online-Zahlungen",
  "paypal":"PayPal",
  "paypal_email":"PayPal-E-Mail",
  "stripe":"Stripe",
  "payment_instructions":"Zahlungsanweisungen",
  "add_instructions":"Fügen Sie Anweisungen hinzu, um bezahlt zu werden:\n- Bankkontoinformationen.\n- Venmo, Zelle, Cash App.\n- Weitere Informationen.",
  "apply_tax_to_documents":"Steuer auf Dokumente anwenden",
  "tax_label":"Steuerbezeichnung",
  "option_1":"Option 1 (%)",
  "option_2":"Option 2 (%)",
  "option_3":"Option 3 (%)",
  "itemsandservices":"Artikel&Dienstleistungen",
  "preview_and_customize":"Vorschau & Anpassen",
  "new_estimate":"Neuer voranschlag",
  "add_itemandservice":"Artikel/Dienstleistung hinzufügen",
  "sub-total":"Zwischensumme",
  "discount":"Rabatt",
  "total":"Gesamt",
  "estimate_notes":"Notizen zum voranschlag",
  "create_estimate":"voranschlag erstellen",
  "new_invoice":"Neue Rechnung",
  "invoice_notes":"Rechnungsnotizen",
  "create_invoice":"Rechnung erstellen",
  "client_details":"Kundendetails",
  "save_changes":"Änderungen speichern",
  "remove_this_client_from_the_document":"Diesen Kunden aus dem Dokument entfernen!",
  "contact":"Kontakt",
  "update_invoice":"Rechnung aktualisieren",
  "item_details":"Artikeldetails",
  "remove_this_item_from_the_document":"Diesen Artikel aus dem Dokument entfernen!",
  "quantity":"Menge",
  "item_quantity_is_required!":"Artikelmenge ist erforderlich!",
  "total_price":"Gesamtpreis",
  "service_details":"Dienstleistungsdetails",
  "remove_this_service_from_the_document":"Diese Dienstleistung aus dem Dokument entfernen!",
  "unit_type":"Einheitstyp",
  "service_quantity_is_required":"Dienstleistungsmenge ist erforderlich!",
  "select_terms":"Bedingungen auswählen",
  "taxable":"Steuerpflichtig",
  "non_taxable":"Steuerfrei",
  "total_estimates":"Gesamt Kostenvoranschläge",
  "total_invoices":"Gesamt Rechnungen",
  "service_name":"Dienstleistungsname",
  "service_price":"Dienstleistungspreis",
  "no_item_found":"Kein Artikel gefunden.",
  "no_service_found":"Keine Dienstleistung gefunden.",
  "select_your_language":"Wählen Sie Ihre Sprache",
  "stripe_invoice_link":"Stripe-Rechnungslink",
  "update_estimate":"voranschlag aktualisieren",
  "sub_total":"Zwischensumme",
  "select_a_currency":"Währung auswählen",
  "reports":"Berichte",
  "customize":"Anpassen",
  "edit":"Bearbeiten",
  "invoices":"Rechnungen",
  "estimates":"Kostenvoranschläge",
  "get_statement":"Abrechnung abrufen",
  "no_client_found_with_the_given_id":"Kein Kunde mit der angegebenen ID gefunden.",
  "no_statement_found":"Keine Abrechnung gefunden",
  "no_document_found_for_this_client":"Kein Dokument für diesen Kunden gefunden.",
  "client_statment":"Kundenabrechnung",
  "send_statment":"Abrechnung senden",
  "update_client":"Kunde aktualisieren",
  "remove_this_item":"Diesen Artikel entfernen",
  "remove_this_service":"Diese Dienstleistung entfernen",
  "set_as_default":"Als Standard festlegen",
  "top_invoiced_clients":"TOP-RECHNUNGSKUNDEN",
  "amount":"Betrag",
  "invoices_up":"RECHNUNGEN",
  "quarter":"Quartal",
  "unpaid":"Unbezahlt",
  "top_invoiced_items":"TOP-RECHNUNGSARTIKEL",
  "quantity_up":"Menge",
  "top_invoiced_services":"TOP-RECHNUNGSDIENSTLEISTUNGEN",
  "last_year":"Letztes Jahr",
  "life_time":"Lebenszeit",
  "ok":"OK",
  "invoice_send_template_subject":"Rechnung #{document_number} von {business_name}",
  "invoice_send_template_email":"Hallo {client_name},\n \nIch hoffe, es geht Ihnen gut.\n \nWir haben eine neue Rechnung (#{document_number}) von {business_name} erstellt.\n \nSie können diese sicher über den folgenden Link einsehen oder herunterladen:\n \n🔗 https://snapbill.app/document/{document_id}\n \nWenn Sie Fragen zu dieser Rechnung haben oder Unterstützung benötigen, zögern Sie bitte nicht, uns unter {business_email} zu kontaktieren.\n \nVielen Dank für Ihr Vertrauen in {business_name}.\n \nWir schätzen Ihre Zusammenarbeit sehr!\n \nMit freundlichen Grüßen,\n \nDas Team von {business_name}",
  "estimate_send_template_subject":"voranschlag #{document_number} von {business_name}",
  "estimate_send_template_email":"Hallo {client_name},\n \nIch hoffe, es geht Ihnen gut.\n \nWir haben einen voranschlag (#{document_number}) von {business_name} für Sie vorbereitet.\n \nSie können diesen sicher über den folgenden Link einsehen oder herunterladen:\n \n🔗 https://snapbill.app/document/{document_id}\n \nWenn Sie Fragen, Anpassungen haben oder fortfahren möchten, antworten Sie einfach auf diese E-Mail oder kontaktieren Sie uns unter {business_email}.\n \nVielen Dank für Ihr Interesse an {business_name}.\n \nWir freuen uns auf die Zusammenarbeit!\n \nMit freundlichen Grüßen,\n \nDas Team von {business_name}",
  "statement_send_template_subject":"Abrechnung von {business_name}",
  "statement_send_template_email":"Hallo {client_name},\n \nIch hoffe, es geht Ihnen gut.\n \nIhre aktuelle Abrechnung von {business_name} ist jetzt verfügbar.\nDiese Abrechnung enthält eine Zusammenfassung Ihrer Rechnungen und Kostenvoranschläge.\n \nSie können diese sicher über den folgenden Link einsehen oder herunterladen:\n \n🔗 https://snapbill.app/statement/{statment_number}\n \nWenn Sie Fragen zu dieser Abrechnung haben oder weitere Details benötigen, zögern Sie bitte nicht, uns unter {business_email} zu kontaktieren.\n \nVielen Dank für Ihr Vertrauen in {business_name}.\n \nMit freundlichen Grüßen,\n \nDas Team von {business_name}",
  "no_internet_connection":"Keine Internetverbindung",
  "you_need_an_internet_connection_to_send_or_share_your_invoice":"Sie benötigen eine Internetverbindung, um Ihre Rechnung zu senden oder zu teilen.\nBitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut, oder wählen Sie eine der Offline-Optionen (Drucken oder als PDF herunterladen), um fortzufahren.",
  "you_need_an_internet_connection_to_send_or_share_your_estimate":"Sie benötigen eine Internetverbindung, um Ihren voranschlag zu senden oder zu teilen.\nBitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut, oder wählen Sie eine der Offline-Optionen (Drucken oder als PDF herunterladen), um fortzufahren.",
  "you_need_an_internet_connection_to_send_or_share_your_statment":"Sie benötigen eine Internetverbindung, um Ihre Abrechnung zu senden oder zu teilen.\nBitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut, oder wählen Sie eine der Offline-Optionen (Drucken oder als PDF herunterladen), um fortzufahren.",
  "error":"Fehler",
  "mail_composer_is_not_available_on_this_device":"Mail Composer ist auf diesem Gerät nicht verfügbar",
  "estimate_full_capital":"voranschlag",
  "invoice_full_capital":"RECHNUNG",
  "estimate_to":"voranschlag AN",
  "invoice_to":"RECHNUNG AN",
  "invoice_no":"Rechnungsnr:",
  "issue_date":"Ausstellungsdatum:",
  "due_date":"Fälligkeitsdatum:",
  "valid_until":"Gültig bis:",
  "description":"Beschreibung",
  "unit_price":"Einzelpreis",
  "note":"Notiz:",
  "number_1":"Nummer 1",
  "number_2":"Nummer 2",
  "bill_to":"Rechnung an",
  "from_full_capital":"VON",
  "details_full_capital":"DETAILS",
  "valid": "Gültig",
  "select_contact": "Kontakt auswählen",
  "no_contacts": "Keine Kontakte gefunden",
  "import_from_contacts": "Aus Kontakten importieren",
  "call": "Anrufen",
  "message": "Nachricht",
  "success": "Erfolg",
  "pdf_saved": "PDF gespeichert! Öffne Dateien → Auf meinem iPhone → SnapBill",
  "not_send": "Nicht gesendet",
  "created": "Erstellt",
  "send_to": "Senden an",
  "signatures": "Unterschriften",
  "signature": "Unterschrift",
  "new_signature": "Neue Unterschrift",
  "signature_name_is_required": "Unterschriftsname ist erforderlich",
  "clear": "Löschen",
  "delete_signature": "Unterschrift löschen",
  "this_action_will_delete_the_signature": "Diese Aktion löscht die Unterschrift.",
  "no_signatures_found": "Keine Unterschriften gefunden",
  "add_your_signature": "Füge deine Unterschrift hinzu",
  "this_action_will_remove_the_signature_from_this_document": "Diese Aktion entfernt die Unterschrift aus diesem Dokument.",
  "on_receipt": "Bei Erhalt",
  "three_days": "3 Tage",
  "ten_days": "10 Tage",
  "thirty_days": "30 Tage",
  "no_duo_date": "Kein Fälligkeitsdatum",
  "no_valid_date": "Kein Gültigkeitsdatum",
  "select_date": "Datum auswählen",
  "percentage": "Prozentsatz",
  "fix": "Fest",
  "please_add_client_detail_to_the_invoice": "Bitte fügen Sie die Kundendetails zur Rechnung hinzu",
  "please_add_at_least_one_item_to_the_invoice": "Bitte fügen Sie der Rechnung mindestens einen Artikel hinzu",
  "please_add_client_detail_to_the_estimate": "Bitte fügen Sie die Kundendetails zum Kostenvoranschlag hinzu",
  "please_add_at_least_one_item_to_the_estimate": "Bitte fügen Sie dem Kostenvoranschlag mindestens einen Artikel hinzu",
  "next": "Weiter",
  "get_started": "Los geht’s",
  "create_invoices_and_estimates_in_seconds": "Erstellen Sie Rechnungen & Kostenvoranschläge in Sekunden",
  "auto_fill_client_details": "Kundendaten automatisch ausfüllen, Vorlagen anwenden und in weniger als 20 Sekunden senden.",
  "get_paid_faster_and_know_it_instantly": "Schneller bezahlt werden & sofort Bescheid wissen",
  "snapbill_notifies_you_the_moment": "SnapBill benachrichtigt Sie, sobald der Kunde Ihre Rechnung öffnet und die Zahlung beginnt. Kein Rätselraten mehr – nur Echtzeit-Updates und schnellerer Cashflow.",
  "see_your_business_in_full_color": "Sehen Sie Ihr Unternehmen in voller Farbe",
  "visualize_income_trends": "Visualisieren Sie Einkommensentwicklungen, verfolgen Sie überfällige Rechnungen und erkennen Sie Ihre Top-Kunden – alles durch intelligente, klare Berichte, die Ihnen helfen, mit Zuversicht zu wachsen.",
  "unlimited_access": "Unbegrenzter Zugriff",
  "not_sure_yet": "Noch nicht sicher?",
  "enable_free_access": "Kostenlosen Zugriff aktivieren",
  "best_offer": "Bestes Angebot",
  "yearly_plan": "Jahresplan",
  "per_week": "pro Woche",
  "three_days_free_trail": "3 Tage kostenlos testen",
  "weekly_plan": "Wochenplan",
  "countinue_with_three_days_free": "Mit 3 Tagen kostenlos fortfahren",
  "countinue_with_best_offer": "Mit dem besten Angebot fortfahren",
  "privacy": "Datenschutz",
  "already_subscribed": "Bereits abonniert?",
  "terms": "Bedingungen",
  "please_select_different_plan": "Bitte wählen Sie einen anderen Plan",
  "your_current_plan": "Ihr aktueller Plan",
  "statment_of_account": "Kontoauszug",
  "statment_date": "Auszugsdatum",
  "classic": "Classic",
  "modern": "Modern",
  "wave": "Wave",
  "estimate_no": "Kostenvoranschlag Nr:",
  "pay_now":"Jetzt bezahlen",
  "copy":"Kopie",
  "copied":"Kopiert",
  "invalid_stripe_invoice_link":"Ungültiger Stripe-Rechnungslink",
  "client_name_viewed_your_invoice_document_number":"{client_name} hat Ihre Rechnung Nr. {document_number} angesehen",
  "client_name_viewed_your_estimate_document_number":"{client_name} hat Ihren Kostenvoranschlag Nr. {document_number} angesehen",
  "client_name_started_paying_invoice":"{client_name} hat die Zahlung für Rechnung Nr. {document_number} über {payment_method} gestartet",
  "good_news":"Gute Neuigkeiten!"
}